// utils/cryptoUtils.js
import CryptoJS from "crypto-js";

// AES Secret Key (Must match the backend key)
const SECRET_KEY = "1234567890123456"; // 16-byte key for AES-128

/**
 * Encrypts data using AES-ECB mode with CryptoJS.
 * @param {string} data - The plaintext data to encrypt.
 * @returns {string} - Encrypted Base64 string.
 */
export const encrypt = (data) => {
  const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString(); // Base64
};

/**
 * Decrypts AES-ECB encrypted data.
 * @param {string} encryptedData - The encrypted Base64 string.
 * @returns {string} - Decrypted plaintext.
 */
export const decrypt = (encryptedData) => {
  try {
    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decryption Error:", error);
    return "DECRYPTION_FAILED";
  }
};